import { useContext } from 'react';
import { ModalContext } from '../contexts/ModalContext';

// ----------------------------------------------------------------------

const useModals = () => useContext(ModalContext);

export default useModals;
